import { Component, Element, Host, Prop, VNode, h } from '@stencil/core';

@Component({
  shadow: true,
  tag: 'abds-select-option',
})
export class SelectOption {
  //--------------------------------------------------------------------------
  //
  // Element
  //
  //--------------------------------------------------------------------------

  @Element() host: HTMLAbdsSelectOptionElement;

  //--------------------------------------------------------------------------
  //
  // Props
  //
  //--------------------------------------------------------------------------

  /**
   * If this Boolean attribute is set, this option is not checkable. Often browsers grey out such control and it won't
   * receive any browsing event, like mouse clicks or focus-related ones.
   */
  @Prop({ reflect: true }) disabled: boolean;

  /**
   * If present, the option will be hidden from view. This can be useful for options such as placeholder that would
   * never be selectable and we want to hide from the visual dropdown.
   */
  @Prop({ reflect: true }) hidden: boolean;

  /**
   * This attribute is text for the label indicating the meaning of the option. If the label attribute isn't defined,
   * its value is that of the element text content.
   */
  @Prop({ reflect: true }) label: string;

  /**
   * If present, this Boolean attribute indicates the option is initially selected. Only one single
   * abds-select-option of an abds-select element may have the selected attribute.
   */
  @Prop({ reflect: true }) selected: boolean;

  /**
   * The content of this attribute represents the value to be submitted with the form, should this option be selected.
   * If this attribute is omitted, the value is taken from the text content of the option element.
   */
  @Prop({ reflect: true }) value: string;

  //--------------------------------------------------------------------------
  //
  // Lifecycle Methods
  //
  //--------------------------------------------------------------------------

  render(): VNode {
    return (
      <Host
        disabled={this.disabled}
        hidden={this.hidden}
        label={this.label}
        selected={this.selected}
        value={this.value}
      >
        <slot />
      </Host>
    );
  }
}
